export default {
  adminList: [],
  adminInfo: null
}
